import { useState, useEffect } from "react";
import "survey-core/defaultV2.css";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import "./index.css";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import { getSurveyQuestions } from "service/userservice/getSurveyQuestions";
import { saveSurveyResponse } from "service/userservice/saveSurveyResponse";
import { convertToTitleCase } from "js/formatting";

import Footer from "components/General/Footer";
import config from "config/config";
import { getImage } from "js/utilities";

export default function PostSurvey({ groupName }) {
  const { user } = useSelector((s) => s.user);
  const [searchParams] = useSearchParams();
  const [surveyJson, setSurveyJson] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSurveyQuestions(groupName)
      .then((response) => setSurveyJson(response))
      .catch(() => setLoading(false));
    window.onbeforeunload = restrictToCloseSurvey;
    function restrictToCloseSurvey() {
      return "You have unfinished changes";
    }
  }, []);

  const survey = new Model(surveyJson);
  if (surveyJson && loading) {
    setLoading(false);
  }

  survey.onProcessHtml.add((sender, options) => {
    if (options.reason === "completed") {
      window.onbeforeunload = null;
      if (!options.html) options.html = "";
      options.html +=
        '<div style="margin: 40px 0; width:100%"><button style="margin: auto" class="sd-btn sd-btn--action sd-navigation__complete-btn" onclick="closeSurvey();">Close Survey</button></div>';
    }
  });
  const closeSurvey = () => {
    window.close();
  };
  window.closeSurvey = closeSurvey;

  const objToString = (obj) => {
    let str = "";
    for (let p in obj) {
      str += p + ":" + obj[p] + "|";
    }
    return str;
  };

  survey.onComplete.add((sender) => {
    const result = objToString(sender.data);
    saveSurveyResponse(
      searchParams.get("uuid"),
      user?.userId,
      surveyJson.surveyGroupId,
      result
    );
  });

  return (
    <>
      <div className="font-body text-theme-text-primary">
        <div className="flex flex-col min-h-screen">
          <div className="container py-4">
            <div className="flex justify-between flex-row-reverse items-center lg:grid lg:gap-x-2 lg:grid-cols-[1fr_max-content_max-content_max-content_max-content] lg:items-center">
              <div className="lg:flex lg:items-center px-0">
                <img
                  src={getImage("logo_blue.png")}
                  className="ui-logo-header"
                  alt={`${convertToTitleCase(config.COMPANY_NAME)} Logo`}
                />
                <div className="9lg:flex text-[color:var(--theme-color-portal-title)] font-semibold ml-6 px-6 border-l border-theme-rule"></div>
              </div>
            </div>
          </div>
          <header className="lg:bg-white shadow-drop">
            <div id="id_header">
              <div id="id_mainMenu">
                <div className="ui-navbar w-64 lg:flex lg:w-full lg:z-auto lg:relative h-12">
                  <div
                    id="id_mobileMenuMask"
                    className="hidden fixed inset-0 w-full h-full bg-ui-gray-dark opacity-40 z-[800] lg:hidden lg:inset-auto lg:z-auto"
                  ></div>

                  <nav
                    aria-label="Main"
                    className="ui-main-menu hidden absolute w-64 z-[802] bottom-0 bg-white lg:flex lg:relative lg:w-full lg:z-auto lg:inset-auto lg:bg-transparent lg:container"
                  ></nav>
                </div>
              </div>
            </div>
          </header>
          <EverlakeLoadingOverlay isLoading={loading}>
            <main
              id="mainContent"
              className="flex flex-col flex-grow container"
            >
              <div className="border border-transparent">
                <div className="container pt-6 pb-4 min-h-12">
                  <Survey model={survey} />
                </div>
              </div>
            </main>
          </EverlakeLoadingOverlay>
          <Footer portal="agent" />
        </div>
      </div>
    </>
  );
}
